<div class="row space-between gap-8">
    <h1>User Summary</h1>
    <rr-btn type="Secondary" iconStart="save" (click)="getCsv()"
        >Export as CSV</rr-btn
    >
</div>

<table class="w100">
    <thead>
        <tr>
            <th>Name + Company</th>
            <th>Account created</th>
            <th>Lastlogin</th>
            <th>Streams</th>
        </tr>
    </thead>
    <tbody>
        @for (user of report; track user) {
            <tr class="card">
                <td>
                    <div class="col">
                        <div class="strong">
                            @if (user.prename === '' && user.lastname == '') {
                                {{ user.email }}
                            } @else {
                                {{ user.email }}
                            }
                        </div>
                        <div class="tiny">{{ user.companyName }}</div>
                    </div>
                </td>
                <td>
                    @if (user.created) {
                        {{ user.created | getLocaldateByTime }}
                    }
                </td>
                <td>
                    @if (user.lastLogin) {
                        {{ user.lastLogin | getLocaldateByTime }}
                    } @else {
                        never
                    }
                </td>
                <td>
                    <table class="w100">
                        @for (stream of user.streams; track stream) {
                            <tr class="card">
                                <td class="col">
                                    <div class="strong">
                                        {{
                                            stream.configId
                                                | getStreamnameByConfigId
                                        }}
                                    </div>
                                    <div class="tiny">{{ stream.name }}</div>
                                </td>
                                <td>
                                    created:
                                    {{ stream.dateCreate | getLocaldateByTime }}
                                </td>
                                <td>
                                    {{
                                        stream.finished === 0
                                            ? 'Not finished'
                                            : 'finished: ' +
                                              (stream.dateUpdate
                                                  | getLocaldateByTime)
                                    }}
                                </td>
                                <td class="duration">
                                    duration:
                                    {{
                                        stream.dateUpdate - stream.dateCreate
                                            | date: 'HH:mm:ss'
                                    }}
                                </td>
                            </tr>
                        }
                    </table>
                </td>
            </tr>
        }
    </tbody>
</table>

<app-token-summary></app-token-summary>
